module.exports = __webpack_public_path__ + "static/media/crdpaganb.c447204d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/public/userarea/crdpaganb.png
// module id = 173
// module chunks = 0